// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ad15728e","981":"c6c88335"}[chunkId] + ".chunk.js";
};